import React from 'react';
import { Button } from 'fronton-react';
import { Header } from './components';
import { useTopCategoriesContainer } from './hooks';

import { TopCategoriesContent } from './components/top-categories-content';

import { ShowMoreCategoriesBtnStyles } from './styles';

export const TopCategoriesContainer = () => {
	const {
		selectedFilterItems,
		topCategories,
		numberOfCardsInARow,
		numberOfShownRows,
		isShowMoreCategoriesBtnVisible,
		showMoreCategoriesBtnHandler,
	} = useTopCategoriesContainer();

	return (
		<>
			<Header />
			<div>
				<TopCategoriesContent
					selectedFilterItems={selectedFilterItems}
					topCategories={topCategories}
					numberOfCardsInARow={numberOfCardsInARow}
					numberOfShownRows={numberOfShownRows}
				/>
			</div>
			{isShowMoreCategoriesBtnVisible && (
				<Button
					kind="regular"
					size="l"
					variant="secondary"
					onClick={showMoreCategoriesBtnHandler}
					className={ShowMoreCategoriesBtnStyles}
					data-qa="show-more-categories-btn"
				>
					Показать еще
				</Button>
			)}
		</>
	);
};
